export const About = () => {
  return (
    <div className="p-5 mb-4 bg-light rounded-3">
      <div className="container-fluid py-5">
        <h1 className="display-5 fw-bold">Information</h1>
        <p className="col-md-8 fs-4">App version <strong>1.0.0</strong></p>
      </div>
    </div>
  )
}